import sliceCreator from '../../index.js';
import {CREATE_ADMIN} from '../../../constants/index.js';
const _postCreateAdminAction = sliceCreator('CREATE_ADMIN', CREATE_ADMIN, 'post');
 
const { asyncAction: postCreateAdminAction, reducer, clearData: clearPostCreateAdminAction } = _postCreateAdminAction;
 
export default reducer;
 
export {
    postCreateAdminAction,
    clearPostCreateAdminAction,
}
 